import { useEffect, useState } from 'react';
import { message } from 'antd';

export interface ContentSettingElementProp {
  value?: string; // 图片的uuid
  url?: string; // 图片的url
  constraint?: {
    maxSize?: number;
    suffixes?: string[];
    cnPlaceHolder?: string;
    enPlaceHolder?: string;
    dropDownOptions?: Array<{ name: string; value: string }>;
  };
}
export interface BGGroupProp {
  collapse?: boolean;
  background?: ContentSettingElementProp;
}
export interface InstructionGroupProp {
  enInstructionAudio: any;
  cnInstructionAudio: any;
  collapse?: boolean;
  cnInstruction?: ContentSettingElementProp;
  enInstruction?: ContentSettingElementProp;
}
export interface ScoreGroupProp {
  collapse?: boolean;
  score?: ContentSettingElementProp;
}
export interface TimeGroupProp {
  collapse?: boolean;
  time?: ContentSettingElementProp;
}
export interface CopyrightGroupProp {
  collapse?: boolean;
  copyright?: ContentSettingElementProp;
}
export interface DifficultyGroupProp {
  collapse?: boolean;
  difficulty?: ContentSettingElementProp;
}
export interface TemplateSkinGroupProp {
  collapse?: boolean;
  templateSkin?: ContentSettingElementProp;
}
export interface TitleGroupProp {
  collapse?: boolean;
  title?: ContentSettingElementProp;
  titleImage?: ContentSettingElementProp;
  subTitle?: ContentSettingElementProp;
  subTitleImage?: ContentSettingElementProp;
  navTitle?: ContentSettingElementProp;
  navTitleImage?: ContentSettingElementProp;
}
export interface CustomizedTagGroup {
  collapse?: boolean;
  customizedTag: {
    values: string[];
  };
}

export interface ContentSettingProp {
  hasSetting?: boolean;
  backgroundGroup?: BGGroupProp;
  instructionGroup?: InstructionGroupProp;
  scoreGroup?: ScoreGroupProp;
  timeGroup?: TimeGroupProp;
  titleGroup?: TitleGroupProp;
  supportKnowledgePoint?: boolean;
  copyrightGroup?: CopyrightGroupProp;
  difficultyGroup?: DifficultyGroupProp;
  templateSkinGroup?: TemplateSkinGroupProp;
  customizedTagGroup?: CustomizedTagGroup;
  previewUrl?: string;
  previewPlatform?: string;
}

function useContentSetting(contentUuid: string) {
  const [contentSetting, setContentSetting] = useState<ContentSettingProp>({});

  const fetchContentSetting = () => {
    const url =
      alo7Api.prefix.host + `/api/v1/business_content_${alo7Nav.subject}/${contentUuid}/setting`;
    alo7Api
      .fetch(url)
      .then(res => {
        nx.$root.content.setting = res;
        setContentSetting(res);
      })
      .catch(err => message.error(err.message));
  };

  useEffect(() => {
    if (contentUuid) {
      fetchContentSetting();
    }
  }, [contentUuid]);

  function handleContentSettingUpdate(elementName: string, value: string, callback?: any) {
    const url =
      alo7Api.prefix.host + `/api/v1/business_content_${alo7Nav.subject}/${contentUuid}/setting`;
    const updateParams = {
      name: elementName,
      value,
    };
    alo7Api
      .fetch(url, {
        method: 'PUT',
        body: JSON.stringify(updateParams),
      })
      .then(res => {
        message.success('保存成功');
        fetchContentSetting();
        if (typeof callback === 'function') callback();
      })
      .catch(err => message.error(err.message));
  }

  return { contentSetting, handleContentSettingUpdate };
}

export default useContentSetting;
